import { Box, Flex } from '@chakra-ui/react';

import { DownloadIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import SearchComponent from 'UiKit/search';
import ButtonSolid from 'UiKit/button/buttonSolid';
import { TextSemiBold } from 'UiKit/typography';
import FilterYearMonthPicker from 'UiKit/filter-year-month-picker';
import FilterDatepicker from 'UiKit/filter-datepicker';
import FilterSelect from 'UiKit/filter-select';
import useGetBrand from 'Domain/brand/useGetBrand';
import useGetExportReportOperators from 'Domain/report-attendance/useGetExportReportOperators';
import useGetExportReportAttendanceHost from 'Domain/report-attendance/useGetExportReportAttendanceHost';

import { useReportAttendanceState } from 'View/report-attendance/state';
import { ReportAttendanceText } from 'View/report-attendance/const';

import styles from './styles.module.css';

const Filter = ({ isFetching, t }) => {
  const { filterState, updateFilterState, selectedTab } = useReportAttendanceState();
  const { mutate: exportOperators } = useGetExportReportOperators();
  const { mutate: exportHost } = useGetExportReportAttendanceHost();

  const handleExport = () => {
    if (selectedTab === 'operator') {
      exportOperators(filterState);
    } else {
      exportHost(filterState);
    }
  };

  const handleFilter = ({ field, value }) => {
    updateFilterState({
      page: 1,
      [field]: value,
    });
  };

  const { data: brandOptions, isLoading: isLoadingBrand } = useGetBrand({ enabled: selectedTab === 'host' });

  return (
    <Box className={styles['filter__container']}>
      <Box className={styles['filter__field--container']}>
        <SearchComponent width="377px" value={filterState?.search} onSearch={(value) => handleFilter({ value, field: 'search' })} />
        <Condition
          statement={selectedTab === 'operator'}
          children={
            <FilterYearMonthPicker
              placeholder={t('filter.selectMonth')}
              value={filterState?.monthYear}
              onChange={(value) => {
                handleFilter({ field: 'monthYear', value });
              }}
            />
          }
        />
        <Condition statement={selectedTab === 'host'}>
          <Flex gap={'12px'}>
            <FilterDatepicker
              placeholder={ReportAttendanceText?.datePlaceholder}
              value={filterState?.startedAt}
              onChange={(value) => handleFilter({ field: 'startedAt', value })}
            />
            <FilterDatepicker
              placeholder={ReportAttendanceText?.datePlaceholder}
              value={filterState?.endedAt}
              onChange={(value) => handleFilter({ field: 'endedAt', value })}
            />
            <FilterSelect
              placeholder={t('filter.selectBrand')}
              isLoading={isLoadingBrand}
              value={filterState?.brand}
              clearable={true}
              width="128px"
              options={brandOptions}
              counterLabel={'Brands'}
              onChange={(value) => handleFilter({ field: 'brand', value })}
              isMulti
            />
          </Flex>
        </Condition>
      </Box>
      <Box>
        <ButtonSolid className={styles['filter__button-export']} onClick={handleExport}>
          <DownloadIcon size="14px" /> <TextSemiBold className={styles['filter_button-export--text']}>{ReportAttendanceText.buttonExportText}</TextSemiBold>
        </ButtonSolid>
      </Box>
    </Box>
  );
};

export default Filter;
